import { render, staticRenderFns } from "./CmgRewardExtrasCampaignDetailModal.vue?vue&type=template&id=0a8b2981&scoped=true&lang=pug"
import script from "./cmg-reward-extras-campaign-detail-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-reward-extras-campaign-detail-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardExtrasCampaignDetailModal.vue?vue&type=style&index=0&id=0a8b2981&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8b2981",
  null
  
)

export default component.exports